export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8366.6fc28c7f.jpg";